exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".resources .resource {\n  padding: 0.75rem 1rem;\n  border-top: 2px solid #e3f0f4; }\n  .resources .resource .item-actions {\n    opacity: 0;\n    transition: all 200ms ease-in; }\n  .resources .resource:hover {\n    cursor: pointer; }\n    .resources .resource:hover .item-actions {\n      opacity: 1; }\n  .resources .resource:hover {\n    background-color: #fcf9f3; }\n  .resources .resource .icon .fa {\n    font-size: 300%;\n    color: #d1d6db; }\n  .resources .resource .title {\n    font-weight: bold; }\n  .resources .resource .description {\n    color: #898a8e;\n    margin-bottom: 1rem; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/resources/resources-list/resources-list.component.scss
// module id = 413
// module chunks = 0